module.exports = __webpack_public_path__ + "img/ldyTitle2.a0952c4c.png";